import * as z from "zod/v4";

export const getCustomerAuthFromCustomerWidgetAuth = {
  name: "getCustomerAuthFromCustomerWidgetAuth" as const,
  input: z.object({ customerWidgetAuthToken: z.string() }),
  output: z.object({
    customerAuthToken: z.string(),
    customerInfo: z.object({
      email: z.string(),
      name: z.string().optional(),
      customerId: z.string().optional(),
    }),
  }),
};
